import { GoBack } from '../GoBack';
import * as S from './styles';

interface Props {
  title: string;
  subtile?: string;
  showGoBack?: boolean;
}

export function PageBanner({ title, subtile, showGoBack = true }: Props) {
  return (
    <S.Container>
      <S.TitleContainer>
        {showGoBack && <GoBack />}
        <div>
          <S.Title fontWeight={700}>{title}</S.Title>
          <S.Subtitle>{subtile}</S.Subtitle>
        </div>
      </S.TitleContainer>
    </S.Container>
  )
}
